export default __webpack_public_path__ + "0ef3736b14b6e0fceba872f80d5924c0.svg";